import React, { createContext, useState } from "react";

const RandomTopicContext = createContext();

const RandomTopicContextProvider = ({ children }) => {
  const [randomTopics, setRandomTopics] = useState([]);

  return (
    <RandomTopicContext.Provider value={{ randomTopics, setRandomTopics }}>
      {children}
    </RandomTopicContext.Provider>
  );
};

export { RandomTopicContextProvider, RandomTopicContext };
